export default "__VITE_ASSET__2QoZnBmg__"